module.exports = __webpack_public_path__ + "img/25968b09f974ba1277c92dd72e5ec446.png";